/**
 * Open the screen where a dashboard Pipeline Actions row's step is done
 * (BM-H3734).
 *
 * Vanessa, 5 Oct 2026: "hitting a row, i expect it to take me to where i
 * need to take that action, but it just takes me to the whole pipeline
 * tracker". Every row in TodayWithMate called navigate('/pipeline').
 *
 * The backend now puts `next_step` on each row (hub/matter_next_step.py,
 * the same answer the matter page banner and the tracker row give), and
 * this opens its action the way NextStepBanner does:
 *
 *   - `conflict_check`: the existing check, through openConflictCheck (Send
 *     OB lives there; the approving director goes to the approval page);
 *   - `ccl`: the client care letter, through openMatterCcl;
 *   - `path`: that screen (the FORF, the Thirdfort review, source of funds).
 *
 * Where the action is only "open the pipeline tracker" (waiting on the
 * client, a filing to retry), or there is no action (waiting on the MLCO),
 * the row opens the matter page instead, which shows the same next step
 * with its button. The whole tracker is the last resort, for a row with no
 * matter reference at all.
 */
import { openConflictCheck } from "./openConflictCheck";
import { openMatterCcl } from "./openMatterCcl";

export function matterPagePath(ref) {
  const r = (ref || "").trim();
  return r ? `/matter/${encodeURIComponent(r)}` : "";
}

export function openPipelineAction({ item, axios, apiBase, navigate, onError }) {
  const ref = (item?.matter_reference || "").trim();
  const action = item?.next_step?.action || null;

  if (action?.kind === "conflict_check" && (action.conflict_check_id || ref)) {
    return openConflictCheck({
      conflictCheckId: action.conflict_check_id, matterRef: ref, axios, apiBase, navigate, onError,
    });
  }
  if (action?.kind === "ccl" && ref) {
    return openMatterCcl({ matterRef: ref, axios, apiBase, navigate, onError });
  }
  if (action?.kind === "path" && action.path && action.path !== "/pipeline") {
    return navigate(action.path);
  }
  const matterPage = matterPagePath(ref);
  if (matterPage) return navigate(matterPage);
  if (item?.conflict_check_id) {
    return openConflictCheck({
      conflictCheckId: item.conflict_check_id, matterRef: "", axios, apiBase, navigate, onError,
    });
  }
  return navigate("/pipeline");
}
